import { Box, Breadcrumbs, Typography } from '@mui/material'
import React from 'react'

interface Props {
    path: string[]
    handleNavBarElementClick: (pathElement: string, index: number) => void
}

const NavigationBar = ({ path, handleNavBarElementClick }: Props) => {
    const barContainerStyle = {
        display: 'flex',
        gap: '10px',
        color: 'white',
        typography: 'label1',
    }
    const pathElementStyle = {
        color: 'red',
        '&:hover': {
            cursor: 'pointer',
        },
    }

    const pathViewElements = path.map((element: string, index: number) => {
        const isLastElement = index === path.length - 1
        const textStyle = {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            color: isLastElement ? 'orange' : 'white',
        }
        return (
            <Box
                onClick={() => {
                    handleNavBarElementClick(element, index)
                }}
                key={index}
                sx={pathElementStyle}>
                <Typography sx={textStyle}>{element}</Typography>
            </Box>
        )
    })

    return (
        <Breadcrumbs maxItems={3} sx={barContainerStyle}>
            {pathViewElements}
        </Breadcrumbs>
    )
}

export { NavigationBar }
